import { render } from "./InfoAboutActionLog.vue?vue&type=template&id=53c405ee&scoped=true&ts=true"
import script from "./InfoAboutActionLog.vue?vue&type=script&lang=ts"
export * from "./InfoAboutActionLog.vue?vue&type=script&lang=ts"

import "./InfoAboutActionLog.vue?vue&type=style&index=0&id=53c405ee&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53c405ee"]])

export default __exports__